import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { statisticsRequest } from "./StatisticsRequest";
import "../../../../css/wallet/History/Statistics.css";

function Statistics({ theme, setStatisticsStatus }) {
  const [active, setActive] = useState(false);

  const { t, i18n } = useTranslation();

  const [data, setData] = useState([]);

  const [requestStatus, setRequestStatus] = useState(false);

  const direction = i18n.language == "fa" ? "rtl" : "ltr";

  useEffect(() => {
    setTimeout(() => {
      setActive(true);
    }, 0);

    statisticsRequest(setRequestStatus, setData);
  }, []);
  return (
    <>
      <div
        className={`shadow ${theme}`}
        onClick={() => {
          setActive(false);
          setTimeout(() => {
            setStatisticsStatus(false);
          }, 150);
        }}
      ></div> 
      <div className={`popupMainDiv hasScroll ${theme} ${active && "active"} ${direction == "ltr" ? "ltr" : "rtl"}`}>
        {requestStatus ? (
          <div className={`jfjkkej3c ${theme} shimmer`}></div>
        ) : (
          <div className="statisticsMainDiv">
            <div className="">{t("Wallet Statistics")}</div> 

            <div className={`kkdjjem3s ${theme}`}>
              <div>
                {t("Total Deposits")}{" "}
                {data[0]?.total_deposits.toLocaleString("en-US")} {t("Toman")}
              </div>
              <div>
                {t("Total Value of Deposits")}{" "}
                {data[0]?.total_value_of_deposits.toLocaleString("en-US")} {"$"}
              </div>
              <div>
                {t("Total Withdrawals")}{" "}
                {data[0]?.total_withdrawals.toLocaleString("en-US")}{" "}
                {t("Toman")}
              </div>
              <div>
                {t("Total Value of Withdrawals")}{" "}
                {data[0]?.total_value_of_withdrawals.toLocaleString("en-US")}{" "}
                {"$"}
              </div>
              <div>
                {t("Total Completed Withdrawals")}{" "}
                {data[0]?.total_completed_withdrawals.toLocaleString("en-US")}{" "}
                {t("Toman")}
              </div>
              <div>
                {t("Total Value of Completed Withdrawals")}{" "}
                {data[0]?.total_value_of_completed_withdrawals.toLocaleString(
                  "en-US",
                )}{" "}
                {t("$")}
              </div>
            </div>

            <div className="">{t("Store Statistics")}</div>

            <div className={`kkdjjem3s ${theme}`}>
              <div>
                {t("Total Products")}{" "}
                {data[0]?.products_count.toLocaleString("en-US")}
              </div>

              <div>
                {t("Total Available Products")}{" "}
                {data[0]?.available_products_count.toLocaleString("en-US")}
              </div>

              <div>
                {t("Total Unavailable Products")}{" "}
                {data[0]?.unavailable_products_count.toLocaleString("en-US")}
              </div>

              <div>
                {t("Total Price of Available Products")}{" "}
                {data[0]?.total_price_of_available_products.toLocaleString(
                  "en-US",
                )}{" "}
                {t("Toman")}
              </div>

              <div>
                {t("Total Value of Available Products")}{" "}
                {data[0]?.total_value_of_available_products.toLocaleString(
                  "en-US",
                )}{" "}
                {t("$")}
              </div>
            </div>

            <div className="">{t("Trade Statistics")}</div>

            <div className={`kkdjjem3s ${theme}`}>
              <div>
                {t("Total of Product Sales")}{" "}
                {data[0]?.total_of_product_sales.toLocaleString("en-US")}
              </div>

              <div>
                {t("Total Price of Products Sales")}{" "}
                {data[0]?.total_price_of_product_sales.toLocaleString("en-US")}{" "}
                {t("Toman")}
              </div>

              <div>
                {t("Total Value of Products Sales")}{" "}
                {data[0]?.total_value_of_product_sales.toLocaleString("en-US")}{" "}
                {t("$")}
              </div>

              <div>
                {t("Total of Completed Products Sales")}{" "}
                {data[0]?.total_of_completed_product_sales.toLocaleString(
                  "en-US",
                )}
              </div>

              <div>
                {t("Total Price of Completed Products Sales")}{" "}
                {data[0]?.total_price_of_completed_product_sales.toLocaleString(
                  "en-US",
                )}{" "}
                {t("Toman")}
              </div>

              <div>
                {t("Total Value of Completed Products Sales")}{" "}
                {data[0]?.total_value_of_completed_product_sales.toLocaleString(
                  "en-US",
                )}{" "}
                {t("$")}
              </div>

              <div>
                {t("Total of Products Purchases")}{" "}
                {data[0]?.total_of_product_purchases.toLocaleString("en-US")}
              </div>

              <div>
                {t("Total Price of Products Purchases")}{" "}
                {data[0]?.total_price_of_product_purchases.toLocaleString(
                  "en-US",
                )}{" "}
                {t("Toman")}
              </div>

              <div>
                {t("Total Value of Products Purchases")}{" "}
                {data[0]?.total_value_of_product_purchases.toLocaleString(
                  "en-US",
                )}{" "}
                {t("$")}
              </div>

              <div>
                {t("Total of Completed Products Purchases")}{" "}
                {data[0]?.total_of_completed_product_purchases.toLocaleString(
                  "en-US",
                )}
              </div>

              <div>
                {t("Total Price of Completed Products Purchases")}{" "}
                {data[0]?.total_price_of_completed_product_purchases.toLocaleString(
                  "en-US",
                )}{" "}
                {t("Toman")}
              </div>

              <div>
                {t("Total Value of Completed Products Purchases")}{" "}
                {data[0]?.total_value_of_completed_product_purchases.toLocaleString(
                  "en-US",
                )}{" "}
                {t("$")}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default Statistics;
